<!-- <div class="hero" alt="hero-image"> -->
<app-login-layout class="login">
  <!-- <div class="heroimage"></div> -->
  <form [formGroup]="loginForm" (ngSubmit)="onLogin()" *ngIf="!tfaFlag">
    <app-input-field class="input-field" [control]="loginForm.get('username')" name="username" placeholder="Username"
      icon="person">
    </app-input-field>
    <app-input-field class="input-field" type="password" autocomplete="current-password"
      [control]="loginForm.get('password')" name="password" placeholder="Password" icon="lock">
    </app-input-field>
    <div *ngIf="loginForm.errors && loginForm.errors.invalidCredidentials" class="login-error">
      Invalid username or password
    </div>
    <div class="login-actions">
      <div class="links">
        <a routerLink="/reset-password">Forgot your password?</a>
      </div>
      <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
      <button type="submit" mat-flat-button color="primary" [disabled]="loading">Sign in</button>
    </div>
  </form>

  <form [formGroup]="authForm" (ngSubmit)="onLogin()" *ngIf="tfaFlag && !adminAuthenticated">
    <h1>Two-factor authentication</h1>
    <p>
      Open the two-factor authentication app on your device and enter your authentication code to verify your
      identity.
    </p>
    <app-input-field label="Authentication Code" [control]="authForm.get('authCode')" name="code" icon="pin"
      autocomplete="off" placeholder="6-digit code">
    </app-input-field>
    <div *ngIf="authForm.errors && authForm.errors.invalidAuthCode" class="login-error">
      The authentication code you entered is invalid. Please try again.
    </div>
    <div class="login-actions">
      <div class="links">
        <a [routerLink]="['/login-with-recovery-code']">Use recovery code</a>
      </div>
      <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
      <button type="submit" mat-flat-button color="primary" [disabled]="authForm.invalid || loading">Verify</button>
    </div>
  </form>
  <app-select-customer *ngIf="adminAuthenticated" [loading]="loading" (customerSelected)="onLogin($event)">
  </app-select-customer>
</app-login-layout>
<!-- </div> -->